import { defineMessages } from 'react-intl'

export default defineMessages({
  'id': {
    id: 'id',
    defaultMessage: 'ID',
  },
  'label': {
    id: 'label',
    defaultMessage: 'Label',
  },
  'category': {
    id: 'category',
    defaultMessage: 'Category',
  },
  'shape': {
    id: 'shape',
    defaultMessage: 'Boundary',
  },
  'area': {
    id: 'area',
    defaultMessage: 'Area (acres)',
  },
  'mapView': {
    id: 'mapView',
    defaultMessage: 'Map View',
  },
})
